import { useRef, useState } from "react";
import Actionbar from "src/components/common/actionbar/Authactionbar";
import LoadingOverlay from "src/components/common/form/LoadingOverlay";
import { Message } from "src/components/common/form/Message";
import { Content_WMS1120_R01 } from "./Content_WMS1120_R01";
import { useWMS1120_R01Store } from "./Store_WMS1120_R01";
import { AgGridReact } from "ag-grid-react";
import {
	WMS1120_R01SalesDto,
	WMS1120_R01SalesLotDto,
	WMS1120_R01ProductBaseDto,
	WMS1120_R01ProductLotDto,
	WMS1120_R01ProductResultDto,
	WMS1120_R01BomDto,
	WMS1120_R01StockDto,
} from "./Dto_WMS1120_R01";
import SearchSection_WMS1120_R01 from "./SearchSection_WMS1120_R01";
import { TableSalesPane_WMS1120_R01 } from "./table/SalesTable_WMS1120_R01";
import { TableProductPane_WMS1120_R01 } from "./table/ProductTable_WMS1120_R01";
import { BottomTableProductResult_WMS1120_R01 } from "./table/ProductResultTable_WMS1120_R01";
import { BottomTableBom_WMS1120_R01 } from "./table/BomTable_WMS1120_R01";
import { BottomTableStock_WMS1120_R01 } from "./table/StockTable_WMS1120_R01";
import useUiuxStore from "src/store/useUiuxStore";
import { useMouseContent } from "src/utils/mouse/mouseContent";

export const Container_WMS1120_R01 = () => {
	const { initData, WMS1120_R01activeTab: activeTab, setWMS1120_R01ActiveTab: setActiveTab } = useWMS1120_R01Store();
	const { setMessage } = useUiuxStore();

	// 그리드 refs
	const salesGridRef = useRef<AgGridReact<WMS1120_R01SalesDto>>(null);
	const salesLotGridRef = useRef<AgGridReact<WMS1120_R01SalesLotDto>>(null);
	const productGridRef = useRef<AgGridReact<WMS1120_R01ProductBaseDto>>(null);
	const productLotGridRef = useRef<AgGridReact<WMS1120_R01ProductLotDto>>(null);
	const productResultGridRef = useRef<AgGridReact<WMS1120_R01ProductResultDto>>(null);
	const bomGridRef = useRef<AgGridReact<WMS1120_R01BomDto>>(null);
	const stockGridRef = useRef<AgGridReact<WMS1120_R01StockDto>>(null);

	const {
		fetchData,
		handleSalesRowClick,
		handleProductRowClick,
		handleSalesLotRowClick,
		handleProductLotRowClick,
		handleProductResultRowClick,
		handleBomRowClick,
	} = Content_WMS1120_R01({
		salesGridRef,
		productGridRef,
		setMessage,
	});

	// 상하 리사이저 설정 (메인 테이블과 하단 테이블 사이)
	const HEIGHT_RESIZER = {
		code: 'WMS1120_R01-height',
		type: 'height' as const,
		storageKey: 'WMS1120_R01-height-split-height',
		min: 20,
		max: 80,
		default: 50
	} as const;

	const mainTableContainerRef = useRef<HTMLDivElement>(null);
	const bottomTableContainerRef = useRef<HTMLDivElement>(null);
	const tableWrapperRef = useRef<HTMLDivElement>(null);
	const isHeightResizing = useRef(false);

	const { 
		splitValue: heightSplitValue,
		handleMouseDown: handleHeightMouseDown,
	} = useMouseContent({
		resizer: HEIGHT_RESIZER,
		isResizing: isHeightResizing,
		containerRef: tableWrapperRef,
		infoRef: bottomTableContainerRef
	});

	const tabs = [
		{ id: 'sales' as const, label: '매출기준' },
		{ id: 'product' as const, label: '생산기준' },
	];

	const BOTTOM_RESIZER1 = {
		code: 'WMS1120_R01-bottom-1',
		type: 'width' as const,
		storageKey: 'WMS1120_R01-bottom-1-split-width',
		min: 20,
		max: 60,
		default: 33.33,
	} as const;

	const bottomContainerRef = useRef<HTMLDivElement>(null);
	const bottomMiddleTableRef = useRef<HTMLDivElement>(null);
	const isBottomResizing1 = useRef(false);

	const {
		splitValue: bottomSplitValue1,
		handleMouseDown: handleBottomMouseDown1,
	} = useMouseContent({
		resizer: BOTTOM_RESIZER1,
		isResizing: isBottomResizing1,
		containerRef: bottomContainerRef,
		infoRef: bottomMiddleTableRef,
	});

	const BOTTOM_RESIZER2 = {
		code: 'WMS1120_R01-bottom-2',
		type: 'width' as const,
		storageKey: 'WMS1120_R01-bottom-2-split-width',
		min: 30,
		max: 70,
		default: 50,
	} as const;

	const bottomRightContainerRef = useRef<HTMLDivElement>(null);
	const bottomRightTableRef = useRef<HTMLDivElement>(null);
	const isBottomResizing2 = useRef(false);

	const {
		splitValue: bottomSplitValue2,
		handleMouseDown: handleBottomMouseDown2,
	} = useMouseContent({
		resizer: BOTTOM_RESIZER2,
		isResizing: isBottomResizing2,
		containerRef: bottomRightContainerRef,
		infoRef: bottomRightTableRef,
	});

	return (
		<div className={`content-container flex flex-col h-full w-full`}>
			
			<Actionbar
				onFetchClick={fetchData}
				onCreateClick={() => {}}
				onDeleteClick={() => {}}
				onSaveClick={() => {}}
				onPrintClick={() => {}}
				onExcelClick={() => {}}
				onInitClick={() => { initData(); }}
			/>
			<SearchSection_WMS1120_R01 onEnterKeyDown={() => { fetchData(); }} />

			{/* 테이블 영역 wrapper */}
			<div className="flex flex-1 flex-col min-h-0" ref={tableWrapperRef}>
				{/* 메인 테이블 영역 */}
				<div className="h-full px-[12px] py-[5px] gap-[4px] min-h-0 flex flex-col" style={{ height: `${heightSplitValue}%` }} ref={mainTableContainerRef}>
					<div
						className="flex items-end mb-[0.1px] bg-white h-[25px]"
						role="tablist"
						aria-label="조회 기준 탭"
					>
						{tabs.map((tab) => {
							const isActive = activeTab === tab.id;
							return (
								<button
									key={tab.id}
									onClick={() => setActiveTab(tab.id)}
									role="tab"
									aria-selected={isActive}
									className={`h-[26px] px-3 text-[12px] font-medium transition-colors border border-gray-300 border-b-0
										${isActive
											? 'bg-white text-black-700 -mb-px shadow-sm'
											: 'bg-gray-100 text-gray-700 hover:bg-gray-200'}
									`}
								>
									{tab.label}
								</button>
							);
						})}
					</div>
					{activeTab === 'sales' ? (
						<TableSalesPane_WMS1120_R01
							salesGridRef={salesGridRef}
							salesLotGridRef={salesLotGridRef}
							onSalesRowClick={handleSalesRowClick}
							onSalesLotRowClick={handleSalesLotRowClick}
						/>
					) : (
						<TableProductPane_WMS1120_R01
							productGridRef={productGridRef}
							productLotGridRef={productLotGridRef}
							onProductRowClick={handleProductRowClick}
							onProductLotRowClick={handleProductLotRowClick}
						/>
					)}
				</div>

				{/* 상하 리사이저 */}
				<div
					className="h-[6px] bg-gray-100 cursor-row-resize hover:bg-gray-300"
					onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleHeightMouseDown('UD', e.nativeEvent)}
					onDragStart={(e: React.DragEvent<HTMLDivElement>) => e.preventDefault()}
					data-comment="상하 리사이저"
				/>

				{/* 하단 테이블 영역 */}
				<div className="h-full px-[12px] py-[5px] gap-[4px] min-h-0" style={{ height: `${100 - heightSplitValue}%` }} ref={bottomTableContainerRef}>
					<div className="flex gap-[4px] h-full w-full min-h-0" ref={bottomContainerRef}>
						<div className="h-full flex flex-col" style={{ width: `${bottomSplitValue1}%` }}>
							<BottomTableProductResult_WMS1120_R01
								gridRef={productResultGridRef}
								onRowClick={handleProductResultRowClick}
							/>
						</div>
						<div
							className="w-[6px] bg-gray-100 cursor-col-resize hover:bg-gray-300"
							onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleBottomMouseDown1('LR', e.nativeEvent)}
							data-comment="리사이저1"
						/>
						<div className="flex gap-[4px] min-h-0" style={{ width: `${100 - bottomSplitValue1}%` }} ref={bottomRightContainerRef}>
							<div className="h-full flex flex-col" style={{ width: `${bottomSplitValue2}%` }} ref={bottomMiddleTableRef}>
								<BottomTableBom_WMS1120_R01
									gridRef={bomGridRef}
									onRowClick={handleBomRowClick}
								/>
							</div>
							<div
								className="w-[6px] bg-gray-100 cursor-col-resize hover:bg-gray-300"
								onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleBottomMouseDown2('LR', e.nativeEvent)}
								data-comment="리사이저2"
							/>
							<div className="h-full flex flex-col" style={{ width: `${100 - bottomSplitValue2}%` }} ref={bottomRightTableRef}>
								<BottomTableStock_WMS1120_R01 gridRef={stockGridRef} />
							</div>
						</div>
					</div>
				</div>
			</div>

			<Message />
		</div>
	);
};

